<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardAudio :cardContent="content" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon icon="chevron-right" class="IconRight" />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>
<script>
import CardAudio from "../../components/template/Chinese1/CardAudio";
import "../../assets/scss/_chineseStyle.scss";
import { mapGetters } from "vuex";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardAudio, LoadingMDL },
  name: "CTA02",
  data() {
    return {
      content: {},
      lang: this.$store.getters["language/getLanguage"],
      pageCode: "",
      baseURL: "CTA0-",
      isModalVisible: false,
      popupData: {},
      cardType: "img",
      isChange: false,
      newPath: "",
      CheckWidth: window.innerWidth.toString(),
      courseCode: "",
      topicId: "",
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      handler: "",
      isCompletedLoad: false,
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      popUp: "template/getPopupData",
      courseTopicID: "courses/getCourseTopicID",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    popUp: function (val) {
      this.popupData = val;
      this.isModalVisible = true;
    },
    isChange: function () {
      this.isModalVisible = false;
      let body = {};
      body.code = this.courseCode;
      if (this.$route.params.id == undefined) {
        body.templateCode =
          `CTA02-` + this.$store.getters["necessary/getCodePage"];
      } else {
        body.templateCode = `CTA02-` + this.$route.params.id;
      }
      this.$store.dispatch("template/fetchContent", body);
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      if (this.condition.length == 0) {
        this.condition.push({
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        });
      } else {
        this.condition = [];
        this.condition.push({
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        });
      }
      this.loading = false;
    },
    loadingGetter: function (val) {
      if (val == true) {
        this.isCompletedLoad = !this.isCompletedLoad;
      }
    },
    isCompletedLoad: function () {
      if (this.handler === "CTA02") {
        let body = {};
        body.code = this.courseCode;
        body.templateCode = this.content.navigate.next.action;
        this.$store.dispatch("template/fetchContent", body);
      } else if (this.handler !== "CTA02") {
        this.$router.push(this.nextAction);
      } else {
        alert("Something went wrong, please contact administrator.");
      }
      this.loading = false
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    if (this.$route.params.id == undefined) {
      body.templateCode =
        `CTA02-` + this.$store.getters["necessary/getCodePage"];
    } else {
      body.templateCode = `CTA02-` + this.$route.params.id;
    }
    this.$store.dispatch("template/fetchContent", body);
    // this.$store.dispatch("courses/fetchCourseTopic", this.courseCode);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + "-" + str[1];
    },
    linkNextTo(path) {
      this.loading = true
      let str = path.navigate.next.action.split("-");
      this.$store.commit("necessary/setCodePage", str[1]);
      let pathTo = "/" + str[0] + "/" + str[1];
      const useTime = this.$helpers.getUseTime();
      this.nextAction = pathTo;
      this.handler = str[0];
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
    linkBackTo(path) {
      let str = path.navigate.previous.action.split("-");
      this.$store.commit("necessary/setCodePage", str[1]);
      let pathTo = "/" + str[0] + "/" + str[1];
      if (str[0] == "HP03") {
        this.$router.push(pathTo);
      }
      let body = {};
      body.code = this.courseCode;
      body.templateCode = path.navigate.previous.action;
      this.$store.dispatch("template/fetchContent", body);
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
  },
};
</script>
<style>
</style>